import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Menu, MenuItem, Button, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import Resource from "common/components/Resource";
import { PREFERRED_LANGS } from "common/constants";
import { find } from "lodash";
import { getLangCode, setLangCode } from "common/storage";

const resourceName = ({ resourceType }) =>
  resourceType === "building" ? "buildings" : "businesses";

const getAvailableLangs = () => {
  let langData = {};
  PREFERRED_LANGS.forEach((lang) => {
    langData[lang.value] = { nativeName: lang.name };
  });

  return langData;
};

const styles = (theme) => ({
  menuItemText: {
    marginLeft: theme.spacing(1),
  },
});

class LanguageSwitcher extends Component {
  state = {
    anchorEl: null,
  };

  handleClick = (e) => {
    this.setState({ anchorEl: e.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  switchLanguage = (language, adminLevel) => {
    this.handleClose();
    setLangCode(adminLevel, language);
    window.location.reload();
  };

  render() {
    const { anchorEl } = this.state;
    const { permissions, urlResource, adminLevel } = this.props;
    const currentPermission =
      find(permissions, {
        resourceId:
          String(urlResource.id) || window.location.pathname.split("/").pop(),
        resourceType: urlResource.singular,
      }) || permissions[0];
    const open = Boolean(anchorEl);
    const lngs = getAvailableLangs();
    const currentLang = getLangCode(adminLevel);

    return (
      <Fragment>
        {currentPermission ? (
          <Resource
            name={resourceName(currentPermission)}
            resourceId={currentPermission.resourceId}
            render={(res) => {
              return res.multilingual ? (
                <Fragment>
                  <Button
                    id="lang-button"
                    aria-controls={open ? "lang-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={this.handleClick}
                  >
                    <Typography
                      component="span"
                      variant="inherit"
                      style={{
                        fontWeight: "bold",
                        fontSize: ".9em",
                        display: "inline",
                      }}
                    >
                      {lngs[currentLang].nativeName}
                    </Typography>
                    <ArrowDropDown />
                  </Button>
                  <Menu
                    id="lang-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={this.handleClose}
                    MenuListProps={{
                      "aria-labelledby": "lang-button",
                    }}
                  >
                    {Object.keys(lngs).map((lng) => {
                      if (currentLang !== lng) {
                        return (
                          <MenuItem
                            key={lng}
                            onClick={() => this.switchLanguage(lng, adminLevel)}
                          >
                            {lngs[lng].nativeName}
                          </MenuItem>
                        );
                      }
                      return null;
                    })}
                  </Menu>
                </Fragment>
              ) : null;
            }}
          />
        ) : (
          <>
            {adminLevel ? null : (
              <Fragment>
                <Button
                  id="lang-button"
                  aria-controls={open ? "lang-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={this.handleClick}
                >
                  <Typography
                    component="span"
                    variant="inherit"
                    style={{
                      fontWeight: "bold",
                      fontSize: ".9em",
                      display: "inline",
                    }}
                  >
                    {lngs[currentLang].nativeName}
                  </Typography>
                  <ArrowDropDown />
                </Button>
                <Menu
                  id="lang-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={this.handleClose}
                  MenuListProps={{
                    "aria-labelledby": "lang-button",
                  }}
                >
                  {Object.keys(lngs).map((lng) => {
                    if (currentLang !== lng) {
                      return (
                        <MenuItem
                          key={lng}
                          onClick={() => this.switchLanguage(lng, adminLevel)}
                        >
                          {lngs[lng].nativeName}
                        </MenuItem>
                      );
                    }
                    return null;
                  })}
                </Menu>
              </Fragment>
            )}
          </>
        )}
      </Fragment>
    );
  }
}

LanguageSwitcher.propTypes = {
  adminLevel: PropTypes.bool,
};

export default withStyles(styles)(LanguageSwitcher);
